import { render, staticRenderFns } from "./HelpCenterIncidentAlert.vue?vue&type=template&id=049e7701&scoped=true"
import script from "./HelpCenterIncidentAlert.vue?vue&type=script&lang=ts"
export * from "./HelpCenterIncidentAlert.vue?vue&type=script&lang=ts"
import style0 from "./HelpCenterIncidentAlert.vue?vue&type=style&index=0&id=049e7701&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049e7701",
  null
  
)

export default component.exports